import type React from "react";
import { useState } from "react";

import type { ModalBaseProps } from "@/components/Modal/Modal";
import { Modal } from "@/components/Modal/Modal";
import { Button } from "@/design-system/Button";
import { Checkbox } from "@/design-system/Checkbox";
import { useTranslation } from "@/translations";

type ExportBookingsModalProps = ModalBaseProps & {
  onExport: (includeHistory: boolean) => void;
};

export function ExportBookingsModal({ isOpened, onOpenChange, onExport }: ExportBookingsModalProps): React.ReactNode {
  const [isHistoryIncluded, setIsHistoryIncluded] = useState(false);
  const { t } = useTranslation();

  const onClickExport = () => {
    onExport(isHistoryIncluded);
    onOpenChange(false);
  };

  return (
    <Modal.Root
      title={t("page.bookings.asset-detail.export.modal.title")}
      description={t("page.bookings.asset-detail.export.modal.description")}
      {...{ isOpened, onOpenChange }}
    >
      <Modal.Body>
        <Checkbox
          name="includeHistory"
          checked={isHistoryIncluded}
          onChange={(e) => setIsHistoryIncluded(e.target.checked)}
          label={t("page.bookings.asset-detail.export.modal.checkbox")}
        />
      </Modal.Body>
      <Modal.Actions>
        <Modal.Close>
          <Button variant="outline" tone="primary">
            {t("common.action.cancel")}
          </Button>
        </Modal.Close>
        <Button variant="filled" onClick={onClickExport}>
          {t("page.bookings.asset-detail.export.modal.button")}
        </Button>
      </Modal.Actions>
    </Modal.Root>
  );
}
